/**
 * @description Hook utilizado para listar opções de formulários
 * @author Diego Sabino Amorim de Araújo
 * @file useOptionService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import actionTypes from 'utils/actionTypes'
import { useDispatch } from 'react-redux'
import { useFetch } from './useFetch'

export const useOptionService = () => {
  const fetch = useFetch()
  const dispatch = useDispatch()

  const listarOpcoesModeloBalistico = async (modelo, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/gerenciamentoBalistica/${modelo}`)
      dispatch({
        type: actionTypes[modelo],
        opcoes: response.data.itens,
      })
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarOpcoesDeModeloAsync = async (modelo, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/opcao/${modelo}`)
      return response.data.itens
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    listarOpcoesModeloBalistico,
    listarOpcoesDeModeloAsync,
  }
}
